import React from 'react';
import { useEnvironment, useExperiments } from '@wix/yoshi-flow-editor';
import { useSelector } from 'react-redux';

import { Route, useCurrentStateAndParams } from 'common/router';

import { selectGroupIdBySlug } from 'store/groups/selectors';

import { AboutGroup } from './AboutGroup';
import { GroupTopics } from './GroupTopics';
import { GroupMembers } from './GroupMembers';
import { UpcomingGroupEvents } from './UpcomingGroupEvents';
import { PostPage } from './PostPage';
import { GroupFeed } from './GroupFeed';

import { classes, st } from '../pageWithInfoBlocks.st.css';

export const DiscussionPage: React.FC = () => {
  const { isMobile } = useEnvironment();
  const { params } = useCurrentStateAndParams();
  const { experiments } = useExperiments();

  const groupId = useSelector(selectGroupIdBySlug(params.slug));
  const useImprovedLayout = experiments.enabled(
    'specs.groups.GroupLayoutImprovements',
  );

  return (
    <div
      className={st(classes.root, {
        mobile: isMobile,
        improvedLayout: useImprovedLayout,
      })}
    >
      <div className={classes.bigColumn}>
        <Route state="group.discussion.feed" component={GroupFeed} />
        <Route state="group.discussion.post" component={PostPage} />
      </div>
      <div className={classes.gap}></div>
      <div className={classes.smallColumn}>
        <AboutGroup groupId={groupId} />
        <GroupMembers groupId={groupId} />

        {isMobile ? null : (
          <>
            <GroupTopics groupId={groupId} />
            <UpcomingGroupEvents groupId={groupId} />
          </>
        )}
      </div>
    </div>
  );
};
